import app from "app.controller"

import queryString                from "qs"
import React, { Component }       from "react"
import { withRouter }             from "react-router-dom"
import { Container, Form, Input } from "semantic-ui-react"
import historyStore               from "stores/historyStore"
import _                          from "lodash"

import searchStore            from "stores/searchStore"

import "style/SearchPage.scss"
import { observer }           from "mobx-react"
import productStore           from "stores/productStore"
import SearchBarWithTypeahead from "./SearchBarWithTypeahead";

export default class SearchBarWithOptions extends Component {
  
  render() {
    const { className = "" } = this.props
    
    return (
      <div className={`${className} w-100 `}>
        <div className="">
          <div className={"w-100"}>
            <SearchForm showSummary/>
          </div>
        </div>
      </div>
    )
  }
}

@withRouter
@observer
export class SearchForm extends Component {
  state = {
    search: ""
  }
  
  handleRef = ( c ) => {
    this.inputRef = c
  }
  
  focus = () => {
    this.inputRef.focus()
  }
  
  constructor() {
    super()
    this.textInput = React.createRef()
  }
  
  handleChangeSearchMode = ( e, data ) => {
    const { checked } = data
    const artnr = checked ? "1" : "0"
    this.setState( { artnr } )
    this.updateQuery( { search: this.state.search, artnr } )
  }
  
  componentDidMount() {
    let query = queryString.parse( this.props.location.search, { ignoreQueryPrefix: true } )
    if ( typeof (query.q) === "string" && query.q && query.q !== "undefined" ) {
      console.log( "Set SEARCH", query )
      this.setState( { search: query.q } )
      searchStore.setSearchTerm( query.q )
    } else {
      this.setState( { search: searchStore.searchTerm } )
      console.log( "Set FROM STORE", searchStore.searchTerm )
    }
    
    // this.refs.namedInput.focus()
    this.focus()
  }
  
  handleSearchSubmit = event => {
    console.log( "UPDATE SEARCH" )
    let history = this.props.history
    let path = `/search?q=${searchStore.searchTerm}`
    history.replace( path )
    event.preventDefault()
  }
  
  updateQuery = ( { search, artnr = 0 } ) => {
    let history = this.props.history
    app.search.change.dispatch( { q: search, artnr } )
    historyStore.setSearch( search, artnr )
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    if ( history.location.pathname !== "/search" ) {
      let path = `/search/?${queryString.stringify( { ...query, q: search, artnr } )}`
      history.replace( path )
    }
  }
  
  throttledUpdate = _.throttle( this.updateQuery, 1000, { trailing: true, leading: false } )
  
  handleSearchChange = event => {
    const search = event.target.value
    const { artnr } = this.state
    this.setState( { search: event.target.value } )
    this.throttledUpdate( { search, artnr } )
    searchStore.setSearchTerm( search )
  }
  
  render() {
    const { loading, showSummary = false } = this.props
    // const results = productStore.searchByQuery.get(searchStore.searchTerm)
    const results = productStore.lastSearchResult
    const sameSearchValue = results && results.searchTerm === searchStore.searchTerm
    return (
      <Form className={"SearchForm"} onSubmit={this.handleSearchSubmit}>
        {/*<SearchBarWithTypeahead/>*/}
        {/*TODO: Activate typeahead => crashes?*/}
        <Input
          style={this.props.style}
          loading={loading}
          icon="search"
          iconPosition="left"
          ref={this.handleRef}
          value={searchStore.searchTerm}
          onChange={this.handleSearchChange}
          fluid
          className=" line"
          placeholder={translate( "Art.Nr, EAN, Name" )}/>
        {showSummary && <div className="black-80 pt2 f6">
          {/*<div className="fr relative z-9"><Checkbox*/}
          {/*onChange={this.handleChangeSearchMode}*/}
          {/*label={<label><span className="white">Nur Artikelnummern</span></label>}/></div>*/}
          <div>
            {(!loading && sameSearchValue) && <div className="animate fadeIn dib black-70 f6">{results && results.size} {translate( results.size > 1 ? "Produkte" : "Produkt" )}</div>}
            {loading && <div className="animate fadeIn dib black-70 f6">&nbsp;</div>}
          </div>
        </div>}
      </Form>
    
    )
  }
}




// WEBPACK FOOTER //
// ./src/theme/lucht-test/components/Search/SearchBarWithOptions.js